export const PageRoutes = Object.freeze({
    HOME: '/',
    ABOUT: '/about',
    HEALTH_INSTITUTIONS: '/health-institutions',
    GOVERNMENT_ENTERPRISES: '/government-enterprises',
    PATIENTS: '/patients',
    '404': '/404'
})